import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthenticationService } from '@app/core/services';
import { Store } from '@ngrx/store';
import { selectAuthState } from '@app/core/store/auth/auth.selectors';
import { AppState } from '@app/core/store/app.state';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthenticationService,
    private store: Store<AppState>
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.store.select(selectAuthState).pipe(
      // Cognito restores its persisted session asynchronously. If we treated the
      // initial empty store as a logout, `logOut` would clear that persisted session
      // every time a protected URL was refreshed.
      filter((auth) => !auth.loading),
      take(1),
      map((auth) => {
        if (!auth.isAuthenticated) {
          this.authService.logOut();
        }
        return auth.isAuthenticated;
      })
    );
  }
}
